import React from 'react';
import { ReoIcon, ReoBalloon } from '@/deps/basic';
import CommonBox from '@/basic/CommonBox/CommonBox';
import type { IProps } from './IComponent';
import useScreenWidthByUA from '@/utils/hooks/useScreenWidthByUA';
import handleUbbTextWithV2 from '@/utils/shared/handleUbbTextWithV2';
import './index.less';

const SupportMode: React.FC<IProps> = (props) => {

    const {
        ctx,
        style,
        list,
        paymentList,
        paymentName
    } = props;

    const scrennWidth = useScreenWidthByUA(ctx?.headers?.userAgent);

    return (
        <CommonBox style={ style }>
            <div className={ 'support-mode-wrap' }>
                <ul className={ 'support-mode' }>
                    {
                        list.map(item => (
                            <li
                                key={ item.name }
                                className={ 'support-item' }
                            >
                                {
                                    scrennWidth < 768
                                        ?   (
                                            <ReoIcon
                                                className={ 'icon' }
                                                width={ 16 }
                                                name={ 'icon-co_success_hollow' }
                                            />
                                        )
                                        : (
                                            <img
                                                className={ 'img' }
                                                src={ item.image.src }
                                                alt={ item.image.alt }
                                            />
                                        )
                                }
                                <div className={ 'support-item-name' }>
                                    <span dangerouslySetInnerHTML={{ __html: handleUbbTextWithV2(item.name, { mode: 'inline' }) }}></span>
                                    {
                                        item.desc ? (
                                            <ReoBalloon
                                                contentClassName={ 'support-item-ballon-content' }
                                                placement={ scrennWidth < 768 ? 'topCenter' : 'bottomLeft' }
                                                className={ 'support-item-ballon' }
                                                content={
                                                    <div dangerouslySetInnerHTML={{ __html: handleUbbTextWithV2(item.desc, { mode: 'normal' }) }}></div>
                                                }
                                            >
                                                <ReoIcon name={ 'icon-icon_question' } />
                                            </ReoBalloon>
                                        ) : null
                                    }
                                </div>
                            </li>
                        )
                        )
                    }
                </ul>
                {
                    paymentList?.length ? (
                        <div className='paymentList-wrap'>
                            <span dangerouslySetInnerHTML={{ __html: handleUbbTextWithV2(paymentName ?? '', { mode: 'inline' }) }}></span>
                            {
                                paymentList.map((item) => {
                                    return (
                                        <img
                                            key={ item.image.src }
                                            className='payment-img'
                                            title={ item.image.alt }
                                            src={ item.image.src }
                                        />
                                    );
                                })
                            }
                        </div>
                    ) : null
                }

            </div>
        </CommonBox>
    );
};

export default SupportMode;
